import React from "react";

// VKLayout: Simple page wrapper — add a navbar or sidebar here if needed.
function VKLayout({ children }) {
  return (
    <div style={{ minHeight: "100vh", background: "#f1f5f9" }}>
      {children}
    </div>
  );
}

export default VKLayout;
